export const THEMES = ['white', 'blue'];
export const ICON_SIZE = {
    HEIGHT: '11',
    WIDTH: '5',
};
